<template>
	<section class="header">
		<div class="container">
			<div class="row">
				<div class="col-12">
					<div class="header__wrapper">
						<a @click="$router.go(-1)" class="header__back">
							<img src="/static/img/arrow.svg" alt="">
							<span>
								{{ $t("back") }}
							</span>
						</a>

						<a :href="`${url}api/judges/${id}/pdf/`" class="header__download">
							<img src="/static/img/download.svg" alt="">
							{{$t('pdf')}}
							<span class="header__download--big">  PDF</span>
						</a>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import axios from 'axios'

	export default {
		props: ['id'],
		data () {
			return {
				url: axios.defaults.baseURL
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../styles/variables.scss";

	.header {
		padding-top: 25px;
		background-color: $gold;
		&__wrapper {
			display: flex;
			justify-content: space-between;
			margin-bottom: 25px;
		}
		&__back {
			cursor: pointer;
			display: flex;
			align-items: center;
			font-family: $lato-bold;
			font-size: 16px;
			letter-spacing: 0.05em;
			text-decoration: none;
			color: $black;
			text-transform: uppercase;
		}
		&__download {
			display: flex;
			align-items: center;
			font-size: 14px;
			text-decoration: none;
			color: $black;
			img {
				margin-right: 15px;
			}
			&--big {
				font-family: $lato-bold;
				margin-left: 5px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Judge/EventHeaderComponent.vue